import {Filter} from '@shared/models/filter.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';

export class Appointments2FilterModel extends Filter {

	type: string[];
	status: any;
	contract: string;
	place: string;
	guests: string;
	date_from: string;
	date_to: string;
	place_type: string;
	place_has_dedicated_expert: string;
	place_center_name: string;
	ald_supplier_id: string;
	place_center_id: string;
	ald_order_id: string;
	search_text: string;
	expires_at_to: string;
	expires_at_from: string;
	contract_plate?: string;

	is_replacement: string;
	surveyor_code: string;

	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			if (model.type) {
				this.type = model.type;
			}
			this.place_type = model.place_type;
			this.place_center_name = model.place_center_name;
			this.ald_supplier_id = model.ald_supplier_id;
			this.place_center_id = model.place_center_id;
			this.place_has_dedicated_expert = model.place_has_dedicated_expert;
			this.ald_order_id = model.ald_order_id;

			if (model.status) {
				this.status = model.status;
			}

			if (model.contract) {
				this.contract = model.contract;
			}
			if (model.search_text) {
				this.search_text = model.search_text;
			}
			if (model.place) {
				this.place = model.place;
			}
			if (model.guests) {
				this.guests = model.guests;
			}
			if (!Utilities.isVoid(model.date_from)) {
				if (typeof model.date_from === 'string') {
					this.date_from = model.date_from;
				} else {
					this.date_from = DateUtilities.getUTCStringFromDate(model.date_from);
				}
			}

			if (!Utilities.isVoid(model.date_to)) {
				if (typeof model.date_to === 'string') {
					this.date_to = model.date_to;
				} else {
					this.date_to = DateUtilities.getUTCStringFromDate(model.date_to);
				}
			}

			if (!Utilities.isVoid(model.expires_at_from)) {
				if (typeof model.expires_at_from === 'string') {
					this.expires_at_from = model.expires_at_from;
				} else {
					this.expires_at_from = DateUtilities.getUTCStringFromDate(model.expires_at_from);
				}
			}

			if (!Utilities.isVoid(model.expires_at_to)) {
				if (typeof model.expires_at_to === 'string') {
					this.expires_at_to = model.expires_at_to;
				} else {
					this.expires_at_to = DateUtilities.getUTCStringFromDate(model.expires_at_from);
				}
			}

			if (!Utilities.isVoid(model.is_replacement)) {
				this.is_replacement = model.is_replacement;
			}

			this.surveyor_code = model.surveyor_code;

			this.page = model.page;
			this.page_size = model.page_size;
			this.order_by = model.order_by;
			this.asc = model.asc;
			this.contract_plate = model.contract_plate;
		}
	}

	newFilter(model?: any): Appointments2FilterModel {
		return new Appointments2FilterModel(model);
	}

	clone(): Appointments2FilterModel {
		return new Appointments2FilterModel(this);
	}

	getFilterUrl(): string {
		let haveAlreadyParams: boolean;
		let filterUrl: string = '?';
		if (!Utilities.isVoid(this.page)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'page=' + this.page;
			haveAlreadyParams = true;
		}

		if (!Utilities.isVoid(this.page_size)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'page_size=' + this.page_size;
			haveAlreadyParams = true;
		}

		if (!Utilities.isVoid(this.order_by)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'order_by=' + this.order_by;
			haveAlreadyParams = true;
		}

		if (!Utilities.isVoid(this.date_from) && Utilities.isVoid(this.date_to)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'date_to=' + DateUtilities.newerUtcDate;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.date_to) && Utilities.isVoid(this.date_from)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'date_from=' + DateUtilities.olderUtcDate;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.date_from)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'date_from=' + DateUtilities.getStringDateFromDate(this.date_from);
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.date_to)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'date_to=' + DateUtilities.getStringDateFromDate(this.date_to);
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.expires_at_from) && Utilities.isVoid(this.expires_at_to)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'expires_at_to=' + DateUtilities.newerUtcDate;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.expires_at_to) && Utilities.isVoid(this.expires_at_from)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'expires_at_from=' + DateUtilities.olderUtcDate;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.expires_at_from)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'expires_at_from=' + DateUtilities.getStringDateFromDate(this.expires_at_from);
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.expires_at_to)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'expires_at_to=' + DateUtilities.getStringDateFromDate(this.expires_at_to);
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.status)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'status=' + this.status;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.type)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'type=' + this.type;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.place_type)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'place-type=' + this.place_type;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.place_center_name)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'place-name=' + this.place_center_name;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.place_center_id)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'place-place_id=' + this.place_center_id;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.ald_supplier_id)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'place-ald_commodity_id=' + this.ald_supplier_id;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.surveyor_code)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'guests-name=' + this.surveyor_code;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.place_has_dedicated_expert)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'place-has_dedicated_expert=' + this.place_has_dedicated_expert;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.ald_order_id)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'contract-ald_order_id=' + this.ald_order_id;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.contract_plate)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'contract-plate=' + this.contract_plate;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.is_replacement)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'is_replacement=' + this.is_replacement;
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.asc)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += ('asc=' + (this.asc ? 0 : 1));
			haveAlreadyParams = true;
		}
		if (!Utilities.isVoid(this.search_text)) {
			if (haveAlreadyParams) {
				filterUrl += '&';
			}
			filterUrl += 'search_text=' + this.search_text;
			haveAlreadyParams = true;
		}
		return filterUrl;
	}


	filterIsOnlyStatus(): boolean {
		//TODO da sistemare vedere AppointmentFilter
		return true;
	}
}

export class Appointments2File {
	filename: string;
	search_fields: FieldsFile;
}

export class FieldsFile {
	status: string[];
	date_from: string;
	date_to: string;
	type?: string;
}

